<template>
<div>
  <div class="mr-r30" style="float:left; width: 300px;">
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h3">서버 목록</div>
      <w-search-field width="160px" @search="searchTree"/>
    </el-row>
    <hr class="mr-b20" style="margin-top: 0px;"/>
    <div style="width: 100%; overflow: auto;">
      <w-physical-tree ref="sideTree" managetype-id="SMS" force-select-leaf @clickNode="onClickNode" :show-search-tool="false"/>
    </div>
  </div>
  <w-major-proc-indivisual-apply class="mr-t10" style="float:right; width: calc(100% - 330px);" :serverId="serverId" :selectPhysicalNode="selectPhysicalNode"></w-major-proc-indivisual-apply>
</div>
</template>

<script>
import WPanel from '@/components/box/Panel';
import cloneDeep from 'lodash/cloneDeep';
import WPhysicalTree from '@/components/tree/DynamicPhysicalTree';
import WSearchField from '@/components/form/SearchField';
import WSettingContentSideTemplate from '@/views/settings/components/template/SettingContentSideTemplate';
import WMajorProcIndivisualApply from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/component/MajorProcIndivisualApply';

export default {
  name: 'WProcessIndividualRegistView',
  components: {
    WPanel,
    WSettingContentSideTemplate,
    WPhysicalTree,
    WMajorProcIndivisualApply,
    WSearchField,
  },
  data() {
    return {
      selectPhysicalNode: null,
      serverId: null,
    };
  },
  watch: {},
  methods: {
    onClickNode(data) {
      this.selectPhysicalNode = data;
      this.serverId = cloneDeep(data.serverId);
    },
    searchTree(value) {
      this.$refs.sideTree.filterTree(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/ProcessIndividualRegistView.vue